(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-gallery-nav"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initGalleryNav(section) {
    var outer = section.closest('.cc-gallery-nav__outer');
    var wrapper = section.querySelector('.cc-gallery-nav__wrapper');
    var items = wrapper.querySelectorAll('.cc-gallery-nav__item');
    var fixedStackGap = parseInt(section.dataset.stackGap) || 20;
    var fillViewport = section.dataset.fillViewport === 'true';
    var initialGap = parseInt(getComputedStyle(section).getPropertyValue('--gap')) || 20;
    var scrollMultiplier = parseFloat(section.dataset.scrollDistance) || 1.5;
    var mobileScrollMultiplier = parseFloat(section.dataset.scrollDistanceMobile) || 0.5;
    var itemCount = parseInt(section.dataset.itemCount) || items.length;

    if (items.length === 0) return;

    var itemData = [];
    var headerHeight = 0;
    var stackGap = fixedStackGap;

    var sectionId = section.id.replace('cc-gallery-nav-', '');
    var lightbox = document.querySelector('#CCLightbox-' + sectionId);
    var imagesDataEl = document.querySelector('#gallery-images-' + sectionId);
    var imagesData = [];

    if (imagesDataEl) {
      try {
        imagesData = JSON.parse(imagesDataEl.textContent);
      } catch (e) {
        console.error('Failed to parse gallery images:', e);
      }
    }

    var lightboxOpen = false;
    var lastViewedIndex = -1;

    // Mobile touch state
    var touchProgress = 1;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartProgress = 0;
    var isSwiping = false;
    var touchDecided = false;

    function isMobile() {
      return window.innerWidth < 750;
    }

    var defaultTransition = 'transform var(--animation-speed, 150ms) var(--animation-easing, ease-out)';

    function scrollToImage(index) {
      var totalSteps = itemCount - 1;
      if (totalSteps <= 0) return;

      lastViewedIndex = index;

      items.forEach(function(item, i) {
        item.style.zIndex = (i === index) ? (items.length + 1) : (i + 1);
      });

      if (!isMobile()) {
        var targetProgress = 1 - (index / totalSteps);
        targetProgress = Math.max(0, Math.min(1, targetProgress));

        var scrollRange = outer.offsetHeight - window.innerHeight;
        var outerTop = outer.getBoundingClientRect().top + window.pageYOffset;
        var currentHeaderHeight = getHeaderHeight();

        var targetScrollY = outerTop + (targetProgress * scrollRange) - currentHeaderHeight;

        window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
      }
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        if (lightbox && lightbox.show) {
          var index = parseInt(item.dataset.index) || 0;
          lightbox.show(item, imagesData, index, scrollToImage);
        }
      });
    });

    function getHeaderHeight() {
      var stickyHeader = document.querySelector('sticky-header');
      return stickyHeader ? stickyHeader.offsetHeight : 0;
    }

    function calculateDynamicStackGap() {
      var currentFillViewport = section.dataset.fillViewport === 'true';
      var currentStackGap = parseInt(section.dataset.stackGap) || 20;

      if (!currentFillViewport || itemData.length < 2) return currentStackGap;

      var lastImageWidth = itemData[itemData.length - 1] ? itemData[itemData.length - 1].width : 0;
      var sectionStyle = getComputedStyle(section);
      var paddingLeft = parseFloat(sectionStyle.paddingLeft) || 0;
      var paddingRight = parseFloat(sectionStyle.paddingRight) || 0;
      var availableWidth = window.innerWidth - paddingLeft - paddingRight;

      var dynamicGap = (availableWidth - lastImageWidth) / (itemCount - 1);
      return Math.max(8, dynamicGap);
    }

    function calculatePositions() {
      itemData = [];
      headerHeight = getHeaderHeight();

      if (!isMobile()) {
        var sectionStyle = getComputedStyle(section);
        var sectionPaddingTop = parseFloat(sectionStyle.paddingTop) || 0;
        var sectionMarginTop = parseFloat(sectionStyle.marginTop) || 0;
        section.style.top = (headerHeight + sectionPaddingTop + sectionMarginTop) + 'px';
      } else {
        section.style.top = '';
      }

      items.forEach(function(item) {
        var rect = item.getBoundingClientRect();
        itemData.push({
          offsetLeft: item.offsetLeft,
          width: rect.width
        });
      });

      stackGap = calculateDynamicStackGap();

      if (!isMobile()) {
        var sectionHeight = section.offsetHeight;
        var scrollHeight = sectionHeight * scrollMultiplier * (itemCount - 1);
        outer.style.height = scrollHeight + sectionHeight + 'px';
      } else {
        outer.style.height = '';
      }
    }

    // Shared position-applying function driven by a 0–1 progress value
    function applyPositions(progress) {
      if (progress <= 0.001) {
        items.forEach(function(item, index) {
          item.style.transform = 'translateX(0)';
          item.style.zIndex = index + 1;
        });
        return;
      }

      var totalSteps = itemCount - 1;
      var currentStep = progress * totalSteps;
      var fullyStackedCount = Math.floor(currentStep);
      var partialProgress = currentStep - fullyStackedCount;

      var originalGap = initialGap;
      if (itemData.length >= 2) {
        originalGap = itemData[1].offsetLeft - (itemData[0].offsetLeft + itemData[0].width);
      }

      var firstImageOffset = itemData[0] ? itemData[0].offsetLeft : 0;

      var positions = [];
      positions[0] = firstImageOffset;

      for (var i = 1; i < items.length; i++) {
        var prevRight = positions[i - 1] + (itemData[i - 1] ? itemData[i - 1].width : 0);

        if (i <= fullyStackedCount) {
          positions[i] = firstImageOffset + i * stackGap;
        } else if (i === fullyStackedCount + 1) {
          var stackedPos = firstImageOffset + i * stackGap;
          var gapPos = prevRight + originalGap;
          positions[i] = gapPos - (gapPos - stackedPos) * partialProgress;
        } else {
          positions[i] = prevRight + originalGap;
        }

        var translateAmount = (itemData[i] ? itemData[i].offsetLeft : 0) - positions[i];
        items[i].style.transform = 'translateX(-' + translateAmount + 'px)';
        items[i].style.zIndex = i + 1;
      }

      items[0].style.transform = 'translateX(0)';
      items[0].style.zIndex = 1;
    }

    function handleScroll() {
      if (isMobile()) return;
      if (lightboxOpen) return;

      var outerRect = outer.getBoundingClientRect();
      var adjustedTop = outerRect.top - headerHeight;
      var scrollProgress = -adjustedTop / (outer.offsetHeight - window.innerHeight);
      scrollProgress = Math.max(0, Math.min(1, scrollProgress));
      scrollProgress = 1 - scrollProgress;

      applyPositions(scrollProgress);
    }

    // --- Mobile touch handlers ---
    section.addEventListener('touchstart', function(e) {
      if (!isMobile()) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartProgress = touchProgress;
      isSwiping = false;
      touchDecided = false;
      items.forEach(function(item) {
        item.style.transition = 'none';
      });
    }, { passive: true });

    section.addEventListener('touchmove', function(e) {
      if (!isMobile()) return;
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      if (!touchDecided) {
        if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
          touchDecided = true;
          isSwiping = Math.abs(dx) > Math.abs(dy);
        }
        if (!touchDecided || !isSwiping) return;
      }

      if (!isSwiping) return;
      e.preventDefault();

      // Swipe left (negative dx) increases progress (stacks images)
      var sectionWidth = section.offsetWidth;
      var progressDelta = -dx / (sectionWidth * mobileScrollMultiplier);
      touchProgress = Math.max(0, Math.min(1, touchStartProgress + progressDelta));
      applyPositions(touchProgress);
    }, { passive: false });

    section.addEventListener('touchend', function() {
      if (!isMobile()) return;
      if (isSwiping) {
        // Snap to nearest discrete step
        var totalSteps = itemCount - 1;
        if (totalSteps > 0) {
          var nearestStep = Math.round(touchProgress * totalSteps);
          touchProgress = nearestStep / totalSteps;
        }
      }
      items.forEach(function(item) {
        item.style.transition = defaultTransition;
      });
      if (isSwiping) {
        applyPositions(touchProgress);
      }
      isSwiping = false;
      touchDecided = false;
    }, { passive: true });

    section.addEventListener('touchcancel', function() {
      items.forEach(function(item) {
        item.style.transition = defaultTransition;
      });
      isSwiping = false;
      touchDecided = false;
    }, { passive: true });

    function onResize() {
      calculatePositions();
      if (isMobile()) {
        applyPositions(touchProgress);
      } else {
        handleScroll();
      }
    }

    calculatePositions();

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', onResize);

    if (isMobile()) {
      applyPositions(touchProgress);
    } else {
      handleScroll();
    }

    if (lightbox) {
      var lbObserver = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'open') {
            if (lightbox.hasAttribute('open')) {
              lightboxOpen = true;
            } else {
              lightboxOpen = false;
              if (lastViewedIndex >= 0) {
                var totalSteps = itemCount - 1;
                if (totalSteps > 0) {
                  var progress = lastViewedIndex / totalSteps;

                  if (isMobile()) {
                    touchProgress = progress;
                    items.forEach(function(item) {
                      item.style.transition = defaultTransition;
                    });
                    applyPositions(touchProgress);
                  } else {
                    applyPositions(progress);
                    var targetProgress = 1 - (lastViewedIndex / totalSteps);
                    var scrollRange = outer.offsetHeight - window.innerHeight;
                    var outerTop = outer.getBoundingClientRect().top + window.pageYOffset;
                    var currentHeaderHeight = getHeaderHeight();
                    var targetScrollY = outerTop + (targetProgress * scrollRange) - currentHeaderHeight;
                    window.scrollTo({ top: targetScrollY, behavior: 'instant' });
                  }
                }
                lastViewedIndex = -1;
              }
            }
            break;
          }
        }
      });
      lbObserver.observe(lightbox, { attributes: true });
    }
  }

  document.querySelectorAll('.cc-gallery-nav').forEach(initGalleryNav);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
